import { UUID_REGEX } from '../consts/consts';

// Returns null when the path carries no uuid segment at all, so callers can
// tell "missing" apart from "present but malformed".
const parseUuidSegment = (pathname: string): string | null => {
  const segments = pathname.split('/').filter(Boolean);
  let pathParts = segments.filter((segment) => segment !== 'v2');

  if (pathParts[0] === 'login' || pathParts[0] === 'form') {
    pathParts = pathParts.slice(1);
  }

  return pathParts.length < 1 ? null : pathParts[0];
};

export const getUuidFromPathname = (pathname: string): string => {
  const segment = parseUuidSegment(pathname);
  return segment !== null && UUID_REGEX.test(segment) ? segment : '';
};

export const extractPathSegments = (pathname: string) => {
  const segment = parseUuidSegment(pathname);

  if (segment === null) {
    throw new Error('Missing parameters in the header');
  }

  if (!UUID_REGEX.test(segment)) {
    throw new Error('Invalid UUID format');
  }

  sessionStorage.setItem('uuid', segment);
};

export const getStoredUuidPathSegment = () => {
  return sessionStorage.getItem('uuid') || '';
};
